import { RouterProvider } from 'react-router-dom';

import { router } from './routes';
import { SessionProvider } from 'auth/SessionProvider';

const App = () => {
  return (
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  );
};

export default App;
